var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "verification-method-modal",
          attrs: {
            id: "accountVerification-verificationMethod",
            visible: _vm.dialogVisibility,
            width: "650px",
            "show-close": true,
            title: "Account Verification",
            "before-close": _vm.processCloseRequest,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibility = $event
            },
            open: _vm.initialize,
          },
        },
        [
          _vm.errorMessage
            ? _c("error-legend", { attrs: { message: _vm.errorMessage } })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "steps-container" },
            [
              _vm.currentVerificationStep ===
              _vm.VERIFICATION_STEPS.METHOD_SELECTION
                ? _c("VerificationMethodSelectionStep", {
                    on: {
                      methodSelected: _vm.setVerificationMethod,
                      nextStepRequested: _vm.setNextStep,
                      previousStepRequested: _vm.setPreviousStep,
                      verificationChannelsUpdated:
                        _vm.updateAvailableVerificationChannels,
                    },
                  })
                : _vm.currentVerificationStep ===
                  _vm.VERIFICATION_STEPS.DATA_CONFIRMATION
                ? _c("DataConfirmationStep", {
                    attrs: {
                      "verification-method-type": _vm.currentVerificationMethod,
                      "is-resend-code-request": _vm.isResendConfirmationCode,
                      icon: _vm.activeIcon,
                      "allowed-verification-methods":
                        _vm.allowedVerificationMethods,
                    },
                    on: {
                      nextStepRequested: _vm.setNextStep,
                      previousStepRequested: _vm.setPreviousStep,
                      connectionError: _vm.showConnectionErrorStep,
                    },
                  })
                : _vm.currentVerificationStep ===
                  _vm.VERIFICATION_STEPS.PASSCODE_CONFIRMATION
                ? _c("PasscodeConfirmationStep", {
                    ref: "passcodeConfirmationStepRef",
                    attrs: {
                      "verification-method-type": _vm.currentVerificationMethod,
                      icon: _vm.activeIcon,
                    },
                    on: {
                      nextStepRequested: _vm.setNextStep,
                      previousStepRequested: _vm.setPreviousStep,
                      errorNotification: _vm.processErrorNotification,
                      complete: _vm.completeAccountVerification,
                      connectionError: _vm.showConnectionErrorStep,
                      tryDifferentMethod: _vm.setTryDifferentMethodStep,
                    },
                  })
                : _vm.currentVerificationStep ===
                  _vm.VERIFICATION_STEPS.RING_APP_VERIFICATIONS_INSTRUCTIONS
                ? _c("RingAppControlCenterInstructions", {
                    attrs: {
                      "verification-method-type": _vm.currentVerificationMethod,
                      icon: _vm.activeIcon,
                    },
                    on: {
                      nextStepRequested: _vm.setNextStep,
                      previousStepRequested: _vm.setPreviousStep,
                      errorNotification: _vm.processErrorNotification,
                      complete: _vm.completeAccountVerification,
                    },
                  })
                : _vm.currentVerificationStep ===
                  _vm.VERIFICATION_STEPS.OVERRIDE_AUTHORIZATION_STEP
                ? _c("VerifyOverride", {
                    on: {
                      cancelOverrideRequested: _vm.cancelOverride,
                      connectionError: _vm.showConnectionErrorStep,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentVerificationStep ===
              _vm.VERIFICATION_STEPS.CONNECTION_ERROR_STEP
                ? _c("InternetConnectionErrorStep", {
                    on: { previousStepRequested: _vm.setPreviousStep },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }